const STORAGE_KEY = "dahuaban-board-favorites";

const readIds = (): string[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.filter((id) => typeof id === "string")
      : [];
  } catch {
    return [];
  }
};

const writeIds = (ids: string[]) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
};

export const boardFavorites = {
  list: () => readIds(),
  has: (id: string) => readIds().includes(id),
  toggle: (id: string) => {
    const ids = readIds();
    const next = ids.includes(id)
      ? ids.filter((item) => item !== id)
      : [...ids, id];
    writeIds(next);
    return next.includes(id);
  },
};
